export const CheckoutSection = {
  BILLING_ADDRESS: "BILLING_ADDRESS",
  SHIPPING_ADDRESS: "SHIPPING_ADDRESS",
  CARD: "CARD"
};

export const CheckoutField = {
  EMAIL: "EMAIL",
  PHONE: "PHONE",
  ZIP: "ZIP",
  STATE_CODE: "STATE_CODE",
  CITY: "CITY",
  STATE: "STATE",
  COUNTRY: "COUNTRY"
};

const BILLING_ADDRESS_SUB_FIELD = "billing_address_sub";

export function defaultBillingCountryFromCheckoutBillingSection(billingAddressSection) {
  const fields = billingAddressSection?.fields;
  if (!fields?.length) {
    return null;
  }
  const countryField = fields
    .find((f) => f.name === BILLING_ADDRESS_SUB_FIELD)
    ?.sub_fields?.find((sf) => sf.name === CheckoutField.COUNTRY.toLowerCase());
  const def = countryField?.def_value;
  return def != null && def !== "" ? def : null;
}

export function billingAddressForTaxEstimate(customerBillingAddress, billingAddressSection) {
  const address = { ...(customerBillingAddress || {}) };
  const country = address.country;
  const needsDefault =
    country == null || (typeof country === "string" && country.trim() === "");
  if (needsDefault) {
    const defaultCountry = defaultBillingCountryFromCheckoutBillingSection(billingAddressSection);
    if (defaultCountry) {
      address.country = defaultCountry;
    }
  }
  return address;
}

export class CommonUtils {
  static validateFormFields(dispatch, hostedPageType, config, checkoutSection, sectionValue) {
    if(!sectionValue) return false;
    switch (checkoutSection) {
      case CheckoutSection.BILLING_ADDRESS: {
        const billingAddressConfig =
          hostedPageType === "checkout"
            ? config.checkout_new?.sections?.billing_address
            : config.sections?.billing_address;
        if (!billingAddressConfig) {
          return false;
        }
        return CommonUtils.validateField(
          dispatch,
          billingAddressConfig,
          CheckoutField.COUNTRY,
          "billing_address_sub",
          CheckoutSection.BILLING_ADDRESS,
          sectionValue
        );
      }
      case CheckoutSection.SHIPPING_ADDRESS: {
        const shippingAddressConfig =
          hostedPageType === "checkout"
            ? config.checkout_new?.sections?.shipping_address
            : config.sections?.shipping_address;
        if (!shippingAddressConfig) {
          return false;
        }
        return CommonUtils.validateField(
          dispatch,
          shippingAddressConfig,
          CheckoutField.COUNTRY,
          "shipping_address_sub",
          CheckoutSection.SHIPPING_ADDRESS,
          sectionValue
        );
      }
      default:
        return false;
    }
  }

  static validateField(
    dispatch,
    addressConfig,
    field,
    fieldName,
    sectionName,
    sectionValue
  ) {
    let isUpdated = false;
    if (!addressConfig) return isUpdated;
    switch (field) {
      case CheckoutField.COUNTRY: {
        const field = addressConfig?.fields
          .find(field => field.name === fieldName)
          ?.sub_fields?.find(
            subField => subField.name === CheckoutField.COUNTRY.toLowerCase()
          );
        const allowedValues = field?.allowed_values?.map(data => data.value);
        if (
          allowedValues &&
          sectionValue?.country &&
          !allowedValues.includes(sectionValue.country)
        ) {
          const updatedAddress = {...sectionValue, [CheckoutField.COUNTRY.toLowerCase()]: undefined}
          dispatch(`reset_and_update_${sectionName.toLowerCase()}_field`, updatedAddress);
          isUpdated = true;
          dispatch("update_warning_field_value", {
            sectionName: sectionName.toLowerCase(),
            subField: CheckoutField.COUNTRY.toLowerCase(),
            warningKey: "INVALID_FIELD",
            value: true
          });
        }
        break;
      }
    }
    return isUpdated;
  }
}
